import React from "react";
import { Box, Grid, TextField } from "@mui/material";
import { ReturnToStationResponse } from "../../../app/models/responseModels/returnToStationResponse";
import SubmitModal from "../../../components/common/modalPopup/SubmitModal";

interface ViewRTSModalProps {
  closeViewRTSModal: CallableFunction;
  onCompleted: CallableFunction;
  returnToStationRowData: ReturnToStationResponse;
}

const ViewRTSModal = ({
  closeViewRTSModal,
  onCompleted,
  returnToStationRowData,
}: ViewRTSModalProps) => {
  const handleSubmit = async () => {
    onCompleted();
    return true;
  };

  return (
    <>
      <SubmitModal
        title="View Return To Station Package"
        asyncOperation={handleSubmit}
        closeSubmitModal={closeViewRTSModal}
        allowSubmit={false}
        size="lg"
        isLoading={false}
        closeModalAfterSubmit={true}
        showSubmitButton={false}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="parcelCenter"
                label="Parcel Center"
                name="parcelCenter"
                size="small"
                fullWidth
                required
                value={returnToStationRowData.parcelCenterLocationName}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="client"
                label="Client"
                name="client"
                size="small"
                fullWidth
                value={returnToStationRowData.shipmentClientName}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="trackingNumber"
                label="Tracking Number"
                name="trackingNumber"
                size="small"
                fullWidth
                value={returnToStationRowData.trackingNumber}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="packageStatus"
                label="Package Status"
                name="packageStatus"
                size="small"
                fullWidth
                value={returnToStationRowData.status}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="statusDate"
                label="Status Date"
                name="statusDate"
                size="small"
                fullWidth
                required
                value={new Date(
                  returnToStationRowData.statusDate
                ).toLocaleString()}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="latestScheduledDelivery"
                label="Latest Scheduled Delivery"
                name="latestScheduledDelivery"
                size="small"
                fullWidth
                required
                value={returnToStationRowData.deliveryDate}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="recipientCity"
                label="Recipient City"
                name="recipientCity"
                size="small"
                fullWidth
                value={returnToStationRowData.shipmentRecipientCity}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="recipientState"
                label="Recipient State"
                name="recipientState"
                size="small"
                fullWidth
                value={returnToStationRowData.shipmentRecipientState}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="recipientZip"
                label="Recipient Zip"
                name="recipientZip"
                size="small"
                fullWidth
                value={returnToStationRowData.shipmentRecipientZip}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                margin="normal"
                id="updatedOn"
                label="Updated On"
                name="updatedOn"
                size="small"
                fullWidth
                required
                value={new Date(
                  returnToStationRowData.updatedOn
                ).toLocaleString()}
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      </SubmitModal>
    </>
  );
};

export default ViewRTSModal;
